(function () {
    'use strict';

    angular.module('eDocumentsApp').controller('UnitOfMeasureDetailController', UnitOfMeasureDetailController);

    UnitOfMeasureDetailController.$inject = ['$scope', '$rootScope', 'previousState', 'entity'];

    function UnitOfMeasureDetailController($scope, $rootScope, previousState, entity) {
        var vm = this;

        vm.unitOfMeasure = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('eDocumentsApp:unitOfMeasureUpdate', function (result) {
            vm.unitOfMeasure = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
